import { render, staticRenderFns } from "./CustomizeLanguage.vue?vue&type=template&id=468c3bc8"
import script from "./CustomizeLanguage.vue?vue&type=script&lang=js"
export * from "./CustomizeLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports